<template>
  <div>
    <div class="flex mb-5">
      <div class="w-6/12">
        <h1 class="text-xl font-bold text-gray-700">Rivers</h1>
      </div>
      <div class="w-6/12">
        <el-switch
          class="mr-5"
          v-model="withDeleted"
          active-text="Inactive"
          inactive-text="Active"
          :active-value="1"
          :inactive-value="0"
          @change="handleWithDeletedChange"
        >
        </el-switch>
        <base-button-primary @click="newRiver" class="float-right"
          >New River</base-button-primary
        >
      </div>
    </div>
    <div class="mb-3">
      <div class="w-full">
        <vue-good-table
          :columns="columns"
          :rows="rivers"
          :search-options="{ enabled: true }"
          :sort-options="{
            enabled: true,
            initialSortBy: { field: 'name', type: 'asc' },
          }"
          :fixed-header="false"
          :pagination-options="{
            enabled: true,
            mode: 'records',
            perPage: 50,
            position: 'bottom',
            perPageDropdown: [25, 50, 100],
            dropdownAllowAll: false,
            nextLabel: 'next',
            prevLabel: 'prev',
            rowsPerPageLabel: 'Rows per page',
            ofLabel: 'of',
          }"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'id'">
              <base-button-primary-extra-small @click="handleEdit(props.row)">
                Edit
              </base-button-primary-extra-small>

              <base-button-white-extra-small
                v-if="!props.row.deleted_at"
                @click="handleDelete(props.row)"
                class="ml-3"
              >
                Make Inactive
              </base-button-white-extra-small>
              <base-button-white-extra-small
                v-else
                @click="handleRestore(props.row)"
                class="ml-3"
              >
                Restore
              </base-button-white-extra-small>
            </span>
            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>
        </vue-good-table>
      </div>
    </div>
    <base-modal :show="showModal" @close="showModal = false" @save="save">
      <template v-slot:header> River </template>
      <template v-slot:main>
        <div class="grid grid-cols-2 gap-4">
          <div>
            <base-label>Name</base-label>
            <base-input v-model="river.name" />
          </div>
          <div>
            <base-label>Fee</base-label>
            <base-percent :value="river.fee" @change="river.fee = $event">
            </base-percent>
          </div>
        </div>
      </template>
    </base-modal>
  </div>
</template>

<script>
import Validator from "../common/Validator";
import BasePercent from "@/components/ui/forms/BasePercent";
import "vue-good-table/dist/vue-good-table.css";
import { VueGoodTable } from "vue-good-table";

export default {
  name: "Rivers",
  components: { BasePercent, VueGoodTable },
  data() {
    return {
      showModal: false,
      river: {
        id: null,
        name: "",
        fee: 0,
      },
      withDeleted: 0,
      columns: [
        {
          label: "Name",
          field: "name",
          width: "80%",
        },
        {
          label: "",
          field: "id",
          sortable: false,
        },
      ],
    };
  },
  methods: {
    handleWithDeletedChange() {
      this.$store.dispatch("river/reload", { withDeleted: this.withDeleted });
    },
    setRiver(row = null) {
      if (row) {
        this.river = {
          id: row.id,
          name: row.name,
          fee: row.fee / 100,
        };
      } else {
        this.river = {
          id: null,
          name: "",
          fee: 0,
        };
      }
    },
    newRiver() {
      this.setRiver();
      this.showModal = true;
    },
    handleEdit(row) {
      this.setRiver(row);
      this.showModal = true;
    },
    handleDelete(row) {
      if (confirm("Are you sure you want to remove this river?")) {
        this.$store
          .dispatch("river/delete_river", { id: row.id })
          .then((resp) => {
            if (!resp.success) return;

            this.$store.dispatch("river/reload", {
              withDeleted: this.withDeleted,
            });
            this.$notify({
              title: "River",
              message: "The river has been removed",
              type: "success",
            });
          });
      }
    },
    handleRestore(row) {
      this.$store
        .dispatch("river/restore_river", { id: row.id })
        .then((resp) => {
          if (!resp.success) return;

          this.$store.dispatch("river/reload", {
            withDeleted: this.withDeleted,
          });
          this.$notify({
            title: "River",
            message: "The river has been restored",
            type: "success",
          });
        });
    },
    save() {
      if (!Validator([{ field: this.river.name, name: "River Name" }])) {
        return;
      }
      this.$store.dispatch("river/save_river", this.river).then((resp) => {
        if (!resp.success) return;

        this.$store.dispatch("river/reload", {
          withDeleted: this.withDeleted,
        });
        this.$notify({
          title: "River",
          message: "Data Saved",
          type: "success",
        });
        this.showModal = false;
        this.setRiver();
      });
    },
  },
  computed: {
    rivers: function () {
      return this.$store.getters["river/getRivers"];
    },
  },
  mounted() {
    this.$store.dispatch("river/all", { withDeleted: this.withDeleted });
  },
};
</script>
